import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useToggle } from 'usehooks-ts';

import { BlueContainer, Button, Paragraph } from '@app/shared/ui/atoms/Common';
import { TaroCardsTitle } from '@app/shared/ui/molecules/DailyCardDescription';
import { cn } from '@app/shared/utils/common';
import { Page } from '@app/routes';
import { questionIcon } from '@app/assets';

export function CardsDescription() {
  const [isOpen, toggleIsOpen] = useToggle(false);
  const { t } = useTranslation();

  return (
    <div className="mt-6 flex flex-col gap-5">
      <div className="grid grid-cols-[1fr_48px] gap-1.5 px-3">
        <Button shadow="blue" className="flex items-center justify-center" asChild>
          <Link to={Page.DAILY_CARD_PREVIEW}>{t('daily_card_description.draw_card')}</Link>
        </Button>
        <Button
          shadow="blue"
          className={cn('flex items-center justify-center', isOpen && 'opacity-50')}
          onClick={toggleIsOpen}
        >
          <img src={questionIcon} alt="question" className="h-6 w-6" />
        </Button>
      </div>

      {isOpen && (
        <BlueContainer className="flex flex-col gap-4">
          <TaroCardsTitle title={t('daily_card_description.cards_title')} />

          <Paragraph className="whitespace-pre-line font-normal" variant="card">
            {t('daily_card_description.cards_description')}
          </Paragraph>
        </BlueContainer>
      )}
    </div>
  );
}
